import { getTruckersRefundableFare } from 'services/freight';
import { useParams } from 'react-router-dom';
import { useContext } from 'react';
import AppContext from 'context';

export const useRefundableFare = () => {
  const { dispatch } = useContext(AppContext);
  const { freightId } = useParams();

  const fetchRefundableFare = async () => {
    dispatch({ type: 'truckers_refundable_tarif_loading' });

    try {
      const { data } = await getTruckersRefundableFare({ encodedFreightId: freightId });

      dispatch({ type: 'truckers_refundable_tarif', payload: [...data.truckers] });
      dispatch({ type: 'truckers_refundable_tarif_loaded' });

      return data;
    } catch (errorMessage) {
      dispatch({ type: 'truckers_refundable_tarif_load_error' });
      return errorMessage;
    } finally {
      dispatch({ type: 'truckers_refundable_tarif_loaded' });
    }
  };

  return { fetchRefundableFare };
};
